import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

export interface NkModalContent {
  title: string;
  content: string;
  closeBtn: string;
  emphasis?: string;
}

@Injectable()
export class NkModalService {
  private _modalSubject = new ReplaySubject<NkModalContent>(1);
  public modal$ = this._modalSubject.asObservable(); // nk-modal component is subscre

  constructor() {}

  public openModal(content: NkModalContent) {
    this._modalSubject.next(content);
  }
}

// expand for more layout features.
